import { Divider, Link, Space } from '@kl/components-v6';
import React, { FC, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTrackPageView } from 'features/tracking';
import { LocalizedText } from 'shared/ui/localized-text';
import { KasperskyLogo, LogoIcon } from 'shared/ui/logo';
import { LanguageImage } from 'shared/ui/app-store-images';
import { useTranslation } from 'shared/lib/localization';
import { StyledFlexContainer } from 'shared/ui/styled-components';
import { StyledLogoWrapper, StyledPageContainer, StyledTextWrapper } from './styled';

export const IosPage: FC = () => {
    const t = useTranslation();
    const [searchParams] = useSearchParams();
    useTrackPageView('landing > get_app > kes_ios');

    const copyInstallToken = useCallback(() => {
        const installToken = searchParams.get('installToken');
        if (installToken) {
            window.navigator.clipboard
                .writeText(installToken)
                .then(() => {
                    console.info('Install token copied to clipboard:', installToken);
                })
                .catch(error => {
                    console.error('Failed to copy install token:', error);
                });
        }
    }, [searchParams]);

    return (
        <StyledFlexContainer $align="center" $justify="center" $width="100%">
            <StyledPageContainer>
                <Space align="center" direction="vertical" justify="center" size={20} width="100%">
                    <StyledLogoWrapper>
                        <KasperskyLogo />
                    </StyledLogoWrapper>
                    <Divider />
                    <LogoIcon />
                    <StyledTextWrapper>
                        <LocalizedText localizationKey="GetApp.EndpointSecurity" type="H3" />
                    </StyledTextWrapper>
                    <StyledTextWrapper>
                        <LocalizedText
                            localizationKey="GetApp.CopyClipboardAgreementText"
                            type="BTR2"
                        />
                    </StyledTextWrapper>
                    <Link href={t('GetApp.link')} target="_blank" onClick={copyInstallToken}>
                        <LanguageImage />
                    </Link>
                </Space>
            </StyledPageContainer>
        </StyledFlexContainer>
    );
};
